import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/taxonomy/base-url';
import type { Skill } from '@/models/taxonomy/skills';

export const useSkillSearch = (term: string) => {
  const { data, isLoading, error } = useQuery<Skill[]>({
    queryKey: [clientKeys.useSkillSearch, term],
    enabled: !!term,
    queryFn: async () => {
      const url = `${baseUrl}/expertise/skills/search?term=${term}`;
      return await falconClient.get(url);
    },
  });

  return useMemo(() => {
    const skills = data || [];
    return { options: skills, isLoading, error };
  }, [data, isLoading, error]);
};
